import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {FormGroup} from '@angular/forms';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class PasswordResetService {

  constructor(private httpClient: HttpClient) { }

  public sendPasswordResetEmail(email: string): Observable<void> {
    return this.httpClient.get<void>(`${environment.backendApiUrl}/v1/users/password/reset_token?email=` + email, httpOptions);
  }

  public resetPassword(token: string, form: FormGroup): Observable<void> {
    return this.httpClient.post<void>(
      `${environment.backendApiUrl}/v1/users/password/reset`,
      {token, password: form.controls.password.value, passwordConfirm: form.controls.passwordConfirm.value},
      httpOptions);
  }
}
